import{validDateString}from"../isDateValid";export var isMonthAndYearFormat=function(a){return validDateString(a)&&3>a.split("-").length};